import { createSlice } from "@reduxjs/toolkit";

const getActiveUploadCount = (data = []) =>
  data.filter(
    (f) =>
      f?.uploadedStatus !== "success" &&
      (f?.uploadedPercentage === undefined || f.uploadedPercentage < 100)
  ).length;

const setTitleMessage = (state) => {
  const remainingFlights = getActiveUploadCount(state.data);
  state.tittleMessage = remainingFlights
    ? `Uploading & Processing ${remainingFlights} ${
        remainingFlights > 1 ? "Flights" : "Flight"
      }`
    : "";
};

const flightUploadProgressSlice = createSlice({
  name: "flightUploadProgressState",
  initialState: {
    tittleMessage: "",
    open: false,
    data: [],
  },
  reducers: {
    createNewFlightUploadProgressAction(state, action) {
      const initialProgress =
        action.payload.newFlightProgressUpload.uploadedPercentage ?? 1;
      void state.data.push({
        ...action.payload.newFlightProgressUpload,
        uploadedPercentage: initialProgress,
      });
      setTitleMessage(state);
    },
    updateFlightUploadedPercentageAction(state, action) {
      const flightName = action.payload.flightName;
      const newPercentage = action.payload.uploadedPercentage;

      let found = false;
      state.data.forEach((item, i) => {
        if (item.flightName === flightName) {
          found = true;
          const currentPercentage = state.data[i]["uploadedPercentage"] || 0;

          // Only update if new percentage is greater than or equal to current (prevent going backwards)
          if (newPercentage >= currentPercentage) {
            state.data[i]["uploadedPercentage"] = newPercentage;
            console.log(
              `Updated flight ${flightName} progress: ${currentPercentage}% -> ${newPercentage}%`
            );
          } else {
            console.log(
              `Skipped backward progress update for ${flightName}: ${currentPercentage}% -> ${newPercentage}%`
            );
          }
        }
      });

      if (!found) {
        console.warn(
          `Flight ${flightName} not found in progress data. Available flights:`,
          state.data.map((d) => d.flightName)
        );
      }
      setTitleMessage(state);
    },
    updateFlightUploadStatusAction(state, action) {
      const { flightName, uploadedStatus } = action.payload;

      void state.data.forEach((item, i) => {
        if (item.flightName === flightName) {
          state.data[i]["uploadedStatus"] = uploadedStatus;
        }
      });

      if (uploadedStatus === "success") {
        state.data = state.data.filter((item) => item.flightName !== flightName);
      }
      setTitleMessage(state);
    },
    deleteFlightUploadProgressEntryAction(state, action) {
      void (state.data = state.data.filter(
        (item) => item.flightName !== action.payload.flightName
      ));
      setTitleMessage(state);
    },
    clearFlightUploadProgressAction(state) {
      void (state.data = []);
      void (state.tittleMessage = "");
    },
  },
});

export const {
  createNewFlightUploadProgressAction,
  updateFlightUploadedPercentageAction,
  updateFlightUploadStatusAction,
  deleteFlightUploadProgressEntryAction,
  clearFlightUploadProgressAction,
} = flightUploadProgressSlice.actions;

export default flightUploadProgressSlice.reducer;
